/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PlatformKillswitchDefinition = {
  defaultExternalNote: string;
  enforcementOwner: string;
  failurePolicy: string;
  identityContract: string;
  key: string;
  principalKinds: Array<string>;
  resourceKinds: Array<string>;
  surfaces: Array<string>;
  transportAdapters: Array<string>;
};

/** @internal */
export const PlatformKillswitchDefinition$inboundSchema: z.ZodMiniType<
  PlatformKillswitchDefinition,
  unknown
> = z.pipe(
  z.object({
    default_external_note: z.string(),
    enforcement_owner: z.string(),
    failure_policy: z.string(),
    identity_contract: z.string(),
    key: z.string(),
    principal_kinds: z.array(z.string()),
    resource_kinds: z.array(z.string()),
    surfaces: z.array(z.string()),
    transport_adapters: z.array(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "default_external_note": "defaultExternalNote",
      "enforcement_owner": "enforcementOwner",
      "failure_policy": "failurePolicy",
      "identity_contract": "identityContract",
      "principal_kinds": "principalKinds",
      "resource_kinds": "resourceKinds",
      "transport_adapters": "transportAdapters",
    });
  }),
);

export function platformKillswitchDefinitionFromJSON(
  jsonString: string,
): SafeParseResult<PlatformKillswitchDefinition, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PlatformKillswitchDefinition$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PlatformKillswitchDefinition' from JSON`,
  );
}
